import { legacyPlugins } from "/app/node_modules/.pnpm/@unhead+vue@3.3.1_@oxc-project+types@0.143.0_esbuild@0.28.1_lightningcss@1.33.0_rolldown@1.2._iyobx3ch4dtkm6qt7kxuuprqly/node_modules/@unhead/vue/dist/legacy.mjs";
export default {
  disableDefaults: true,
  plugins: legacyPlugins,
}